{
  "hero": {
    "title": "Make gold like <em>it's your job.<br/></em>",
    "subtitle": "Cross-realm flipping intelligence for the Retail auction house. Live data, surfaced as the deals you should actually take — not another chart to read.",
    "ctaPrimary": "Start a free trial",
    "ctaSecondary": "See it in motion",
    "stats": {
      "regions": "Regions",
      "regionsValue": "EU · US",
      "updated": "Refresh rate",
      "updatedValue": "Hourly"
    }
  },
  "toolsSection": {
    "label": "Tools",
    "sectionTitle": "Six instruments. One job: gold.",
    "watchDemo": "Watch demo",
    "tags": {
      "flippingTool": "Cross-realm",
      "dropshipTool": "Empty markets",
      "realmStats": "Intel",
      "tsmListGenerator": "TSM export",
      "snipeAlerts": "Realtime",
      "inventoryAnalysis": "Bag scan"
    }
  },
  "tools": {
    "flippingTool": {
      "title": "Flipping Tool",
      "description": "Cross-realm flipping tool that analyses the best possible deals for an item.",
      "videoTitle": "Cross-Realm Flipping Tool",
      "features": {
        "0": "Find the best possible deal for an item based of live data.",
        "1": "Select specific realms that you want to buy and sell on.",
        "2": "Shows gold profit from buy vs sell realm.",
        "3": "Calculates profit % for sale avg vs buy and sell vs buy.",
        "4": "Shows exactly which realm / realm cluster to buy from and sell on.",
        "5": "Filters / sorting for different type of items and price stats"
      }
    },
    "dropshipTool": {
      "title": "Dropship Tool",
      "description": "Dropship tool which shows you what items are not listed on a server so you can flip it without competition.",
      "videoTitle": "Dropship Tool",
      "features": {
        "0": "Find the best server to sell without competition",
        "1": "Select specific realms that you want to buy and sell on.",
        "2": "Shows gold profit from buy vs sell realm.",
        "3": "Calculates profit % for sale avg vs buy and sell vs buy.",
        "4": "Shows exactly which realm / realm cluster to buy from and sell on.",
        "5": "Filters / sorting for different type of items and price stats"
      }
    },
    "realmStats": {
      "title": "Realm Stats",
      "description": "Statistical information about each realm, price and auction information. This can help you to decide where to buy and where to sell.",
      "videoTitle": "Realm Stats",
      "features": {
        "0": "Find price information about each realm",
        "1": "See which server sells high or low"
      }
    },
    "tsmListGenerator": {
      "title": "TSM List Generator",
      "description": "Advanced TSM list generator tool to make custom item lists based of data.",
      "videoTitle": "TSM List Generator",
      "features": {
        "0": "Use multiple price sources to filter out the best items",
        "1": "Craft the perfect TSM list based of a wide range of data.",
        "2": "Export your custom TSM list with 1 click."
      }
    },
    "snipeAlerts": {
      "title": "Snipe Alerts",
      "description": "Get notified the moment underpriced items, pets, or ilvl BoEs appear on the auction house — before anyone else can snag them.",
      "videoTitle": "Snipe Alerts Preview",
      "features": {
        "0": "Monitor items, battle pets, and ilvl BoEs below your target price.",
        "1": "Receive instant Discord DM or webhook alerts when a snipe is found.",
        "2": "Configure per-item thresholds with a simple and clean interface."
      }
    },
    "inventoryAnalysis": {
      "title": "Inventory Analysis",
      "description": "Paste your FlipQueue addon inventory CSV to instantly see which items you hold are worth flipping cross-realm right now. Use the result in the addon to list on the best servers.",
      "videoTitle": "Inventory Analysis",
      "features": {
        "0": "Analyse your current inventory against live cross-realm prices.",
        "1": "Instantly spot which items in your bags are profitable to flip."
      }
    }
  },
  "edge": {
    "label": "The edge",
    "sectionTitle": "Why members keep their subscription.",
    "items": {
      "0": {
        "title": "Make more gold.",
        "body": "We surface the highest-margin flips per minute of effort. Your gold-per-hour rate is the number we optimise."
      },
      "1": {
        "title": "Save your evenings.",
        "body": "Hours of TSM scans collapse into one queryable interface. Filter, sort, ship a TSM list, done."
      },
      "2": {
        "title": "Start tonight.",
        "body": "No spreadsheets, no addon overhead. Most members make their first profitable flip on day one."
      }
    }
  },
  "reviews": {
    "label": "Reviews",
    "sectionTitle": "What our members say.",
    "videoTitle": "FlippingPal member reviews"
  },
  "pricing": {
    "label": "Membership",
    "sectionTitle": "One subscription. Every tool.",
    "subtitle": "The subscription gives access to all of the Flipping Pal tools."
  },
  "faq": {
    "label": "Questions",
    "sectionTitle": "Frequently asked questions.",
    "items": {
      "0": {
        "question": "Do I get access to all the tools with the monthly subscription?",
        "answer": "Yes, you will have full access to all of Flipping Pal tools."
      },
      "1": {
        "question": "What WoW region does this work on?",
        "answer": "Both US (NA) and EU (Europe)."
      },
      "2": {
        "question": "Can I cancel my subscription anytime?",
        "answer": "Yes you can, cancel your subscription at anytime. Once you cancel it, you will lose access to the tools."
      },
      "3": {
        "question": "What payment methods are accepted?",
        "answer": "Any debit/credit card."
      },
      "4": {
        "question": "If I have any questions, will I get help?",
        "answer": "Yes, if you have any questions ask the team in the Discord."
      }
    }
  },
  "modal": {
    "close": "Close"
  },
  "backToTop": "Back to top",
  "footerCta": {
    "joinAsAffiliate": "Join as an affiliate",
    "contactUs": "Contact Us",
    "discord": "Discord",
    "refundPolicy": "Refund Policy",
    "privacyPolicy": "Privacy Policy",
    "termsAndConditions": "Terms and Conditions",
    "copyright": "© 2026 Flipping Pal - All rights reserved. By",
    "creatorLabel": "Boophie (Content Creator)"
  }
}
